module.exports = __webpack_public_path__ + "img/closexmark.e643fdfc.svg";